module.exports = __webpack_public_path__ + "static/img/weather_038.ebaf16e8.svg";